<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <mat-form-field style="width: 95%">
    <mat-label>Tekst</mat-label>
    <textarea style="height: 12em;" matInput [(ngModel)]="text"></textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Annullér</button>
  <button mat-button (click)="onSubmit()" cdkFocusInitial>Ok</button>
</div>